// Official Organization Logos
// Import actual logo files

// Current Positions
import iucysLogo from "../images/yoga.webp"; // Already available

// Government Institutions
import bsuscLogo from "./BSUSC.webp";
import hpPublicServiceLogo from "./hpPublicservice.webp";
import mpGovLogo from "./madhya-pradesh-logo.webp";
import naacLogo from "./naac.webp";
import oavsLogo from "./oavs.webp";
import ranipadmavatiLogo from "./ranipamavati.webp";
import ugcLogo from "./ugc_logo.webp";

// Universities
import bhuLogo from "./BHU.webp"; // Banaras Hindu University
import csuLogo from "./csu.webp"; // Central Sanskrit University
import guruNanakLogo from "./GuruNanakDevUni.webp"; // Guru Nanak Dev University
import hpuLogo from "./hpu.webp"; // Himachal Pradesh University
import jagadguruLogo from "./jagadguru-university-logo.webp";
import jnuLogo from "./JNU.webp"; // Jawaharlal Nehru University
import magadhLogo from "./MagadhUni.webp"; // Magadh University
import maharshiValmikiLogo from "./maharsivalmiki.webp"; // Maharishi Valmiki Sanskrit University
import mewarLogo from "./MewarUni.webp"; // Mewar University
import rashtriyaSanskritLogo from "./rashtriyaSanskrit.webp"; // Rashtriya Sanskrit Sansthan
import slbsLogo from "./slbs-university-logo.webp";
import ssuvLogo from "./ssuv.webp"; // Sampurnanand Sanskrit University
import uttarakhandSanskritLogo from "./uttrakhandSanskritUni.webp"; // Uttarakhand Sanskrit University

// Cultural Organizations
import kalidasSamitiLogo from "./KalidasSamiti.webp";
import kashiVishwanathLogo from "./kashi-vishwanath-logo.webp";
import kumbhConclaveLogo from "./kumbh-conclave-logo.webp";
import sanskritBhartiLogo from "./sanskrit-bharti-logo.webp";
import sanskritHeritageLogo from "./sanskritHeritage.webp";

// Educational Institutions
import laxmiDeviLogo from "./LaxmiDevi.webp";
import shriBhagwanSanskritLogo from "./shri_bhagwan_sanskrit_mahavidyalaya.webp";

// Export logos with fallback to default icons
export const organizationLogos = {
    // Current Positions
    "Centre for Yogic Sciences (IUC-YS)": { type: 'image', src: iucysLogo, alt: "Centre for Yogic Sciences" },
    "Sampurnanand Sanskrit University": { type: 'image', src: ssuvLogo, alt: "Sampurnanand Sanskrit University" },
    
    // Government Institutions
    "University Grants Commission (UGC)": { type: 'image', src: ugcLogo, alt: "University Grants Commission" },
    "NAAC 'A' Grade Achievement (2024)": { type: 'image', src: naacLogo, alt: "NAAC A Grade" },
    "Government of Madhya Pradesh": { type: 'image', src: mpGovLogo, alt: "Government of Madhya Pradesh" },
    "Himachal Pradesh Public Service Commission": { type: 'image', src: hpPublicServiceLogo, alt: "Himachal Pradesh Public Service Commission" },
    "Bihar State University Service Commission": { type: 'image', src: bsuscLogo, alt: "Bihar State University Service Commission" },
    "Odisha Adarsha Vidyalaya Sangathan": { type: 'image', src: oavsLogo, alt: "Odisha Adarsha Vidyalaya Sangathan" },
    "Rani Padmavati Tara Yog Tantra Adarsh Sanskrit Mahavidyalaya": { type: 'image', src: ranipadmavatiLogo, alt: "Rani Padmavati Tara Yog Tantra Mahavidyalaya" },
    
    // Universities
    "Banaras Hindu University (BHU)": { type: 'image', src: bhuLogo, alt: "Banaras Hindu University" },
    "Jawaharlal Nehru University": { type: 'image', src: jnuLogo, alt: "Jawaharlal Nehru University" },
    "Jawaharlal Nehru University, New Delhi": { type: 'image', src: jnuLogo, alt: "Jawaharlal Nehru University" },
    "Central Sanskrit University": { type: 'image', src: csuLogo, alt: "Central Sanskrit University" },
    "Central Sanskrit University, New Delhi": { type: 'image', src: csuLogo, alt: "Central Sanskrit University" },
    "Guru Nanak Dev University": { type: 'image', src: guruNanakLogo, alt: "Guru Nanak Dev University" },
    "Guru Nanak Dev University, Amritsar": { type: 'image', src: guruNanakLogo, alt: "Guru Nanak Dev University" },
    "Mewar University": { type: 'image', src: mewarLogo, alt: "Mewar University" },
    "Mewar University, Chittorgarh, Rajasthan": { type: 'image', src: mewarLogo, alt: "Mewar University" },
    "Magadh University": { type: 'image', src: magadhLogo, alt: "Magadh University" },
    "Magadh University, Bodhgaya": { type: 'image', src: magadhLogo, alt: "Magadh University" },
    "Uttarakhand Sanskrit University": { type: 'image', src: uttarakhandSanskritLogo, alt: "Uttarakhand Sanskrit University" },
    "Uttarakhand Sanskrit University, Haridwar": { type: 'image', src: uttarakhandSanskritLogo, alt: "Uttarakhand Sanskrit University" },
    "Maharishi Valmiki Sanskrit University": { type: 'image', src: maharshiValmikiLogo, alt: "Maharishi Valmiki Sanskrit University" },
    "Maharishi Valmiki Sanskrit University, Kaithal, Haryana": { type: 'image', src: maharshiValmikiLogo, alt: "Maharishi Valmiki Sanskrit University" },
    "Rashtriya Sanskrit Sansthan": { type: 'image', src: rashtriyaSanskritLogo, alt: "Rashtriya Sanskrit Sansthan" },
    "Rashtriya Sanskrit Sansthan, New Delhi": { type: 'image', src: rashtriyaSanskritLogo, alt: "Rashtriya Sanskrit Sansthan" },
    "Himachal Pradesh University": { type: 'image', src: hpuLogo, alt: "Himachal Pradesh University" },
    "Shri Lal Bahadur Shastri National Sanskrit University": { type: 'image', src: slbsLogo, alt: "SLBS University" },
    "Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeeth": { type: 'image', src: slbsLogo, alt: "SLBS University" },
    "Shri Lal Bahadur Shastri Rastriya Sanskrit Vidyapeetha": { type: 'image', src: slbsLogo, alt: "SLBS University" },
    "Jagadguru Rambhadracharya Divyang University": { type: 'image', src: jagadguruLogo, alt: "Jagadguru Rambhadracharya Divyang University" },
    "Jagadguru Rambhadracharya Divyang University, Chitrakoot, Uttar Pradesh": { type: 'image', src: jagadguruLogo, alt: "Jagadguru Rambhadracharya Divyang University" },
    
    // Cultural Organizations
    "Sanskrit Bharti": { type: 'image', src: sanskritBhartiLogo, alt: "Sanskrit Bharti" },
    "Sanskrit Bharti, Delhi": { type: 'image', src: sanskritBhartiLogo, alt: "Sanskrit Bharti Delhi" },
    "Shri Kashi Vishwanath Mandir": { type: 'image', src: kashiVishwanathLogo, alt: "Shri Kashi Vishwanath Mandir" },
    "Shri Kashi Vishwanath Mandir Varanasi": { type: 'image', src: kashiVishwanathLogo, alt: "Shri Kashi Vishwanath Mandir Varanasi" },
    "Cultural Heritage Preservation": { type: 'image', src: sanskritHeritageLogo, alt: "Cultural Heritage Preservation" },
    "Kalidas Samiti": { type: 'image', src: kalidasSamitiLogo, alt: "Kalidas Samiti" },
    "Kalidas Samiti, Ujjain": { type: 'image', src: kalidasSamitiLogo, alt: "Kalidas Samiti Ujjain" },
    "Kumbh Conclave 2024–25": { type: 'image', src: kumbhConclaveLogo, alt: "Kumbh Conclave 2024-25" },
    
    // Educational Institutions
    "Shri Bhagwan Das Adarsh Sanskrit Mahavidyalaya": { type: 'image', src: shriBhagwanSanskritLogo, alt: "Shri Bhagwan Das Adarsh Sanskrit Mahavidyalaya" },
    "Laxmi Devi Shroff Adarsh Sanskrit Mahavidyalaya": { type: 'image', src: laxmiDeviLogo, alt: "Laxmi Devi Shroff Adarsh Sanskrit Mahavidyalaya" },
    "Laxmi Devi Shroff Adarsh Sanskrit Mahavidyalaya, Deoghar, Jharkhand": { type: 'image', src: laxmiDeviLogo, alt: "Laxmi Devi Shroff Adarsh Sanskrit Mahavidyalaya" },
    "Ranipadmavati Tara Yogita Adarsh Sanskrit Mahavidyalaya": "🏫",
    "Adarsh Sanskrit Mahavidyalaya": "✅"
};

// Helper function to get logo or fallback
export const getOrganizationLogo = (institutionName) => {
    const logo = organizationLogos[institutionName];
    
    // If it's a string (emoji), return it directly
    if (typeof logo === 'string') {
        return logo;
    }
    
    // If it's an imported image object, return it
    if (logo && typeof logo === 'object' && logo.type === 'image') {
        return logo;
    }
    
    // Default fallback
    return "🏛️";
};
